import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import GuessButton from "../../../ActionPanel/GuessButton";
import sadLogo from "../../../../Assets/sad-newsie-192-removebg.png";

import LeaderBoard from "../../modals/HamburgerMenu/pages/Default/LeaderBoard";
import IncorrectGuesses from "../../../ActionPanel/GameDetails/IncorrectGuesses";
import Stopwatch from "../../../ActionPanel/GameDetails/Stopwatch";
import StoryContainer from "../../../StoryComponents/StoryContainer";

import "./Loser.css";
import PerformanceUpdate from "../Winner/PerformanceUpdate";
import Score from "../../../ActionPanel/GameDetails/Score";
import { generateShareCardBlob } from "../../../../util/shareCard";

const Loser = () => {
  const [shareImageBlob, setShareImageBlob] = useState<Blob | null>(null);
  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );
  const dailyTopScores = useSelector(
    (state: any) => state.metaReducer.dailyTopScores
  );

  const timer = useSelector((state: any) => state.gameReducer.timer[selectedNewsie]);

  const incorrectGuesses = useSelector(
    (state: any) => state.gameReducer.incorrectGuesses[selectedNewsie]
  );
  const unsolvedStories = useSelector((state: any) =>
    state.gameReducer.stories && state.gameReducer.stories[selectedNewsie]
      ? Object.values(state.gameReducer.stories[selectedNewsie])
      : []
  );
  const { time } = useSelector((state: any) =>
    state.gameReducer.timer && state.gameReducer.timer[selectedNewsie]
      ? state.gameReducer.timer[selectedNewsie]
      : { time: -1 }
  );
  const SCORE = 1000 - time - 10 * incorrectGuesses;

  const guessSequence = useSelector(
    (state: any) => state.gameReducer.guessSequence?.[selectedNewsie] || []
  );
  const lastNewsieUpdateDate = useSelector(
    (state: any) => state.gameReducer.lastNewsieUpdateDate
  );
  const performanceUpdateStreak = useSelector(
    (state: any) => state.gameReducer.performanceUpdate?.currentStreak
  );
  const persistedStreak = useSelector(
    (state: any) => state.userPerformanceReducer.currentStreak
  );
  const streak = performanceUpdateStreak || persistedStreak;

  useEffect(() => {
    generateShareCardBlob({
      won: false,
      score: SCORE,
      incorrectGuesses,
      category: selectedNewsie,
      date: lastNewsieUpdateDate,
      guessSequence,
      streak,
    }).then(setShareImageBlob).catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="loser-modal">
      <div className="loser-modal-header-text-container">
        <h4>So close!</h4>
        <h4>
          Here's today's answer{unsolvedStories.length > 1 ? "s" : ""}:
        </h4>
      </div>
      <div className="loser-modal-mr-newsie">
        <img src={sadLogo} alt="Logo" />
      </div>

      <div className="unsolved-stories-container">
        {(unsolvedStories as any[]).map((story, i) => (
          <StoryContainer key={i} story={story} showTitle />
        ))}
      </div>

      <div className="completed-game-final-details-container">
        <div className="completed-time-container">
          <Stopwatch />
        </div>
        <IncorrectGuesses incorrectGuesses={incorrectGuesses} />
        <Score score={SCORE} />
      </div>
      <PerformanceUpdate />
      <div className="title-description-divider" />
      <LeaderBoard
        leaderBoardTitle="Today's Top Scores"
        leaderBoardData={dailyTopScores}
      />
      <div className="share-button-wrapper">
        <GuessButton
          modal
          gameOver={true}
          guessable={true}
          won={false}
          time={timer?.time}
          score={SCORE}
          incorrectGuesses={incorrectGuesses}
          shareImageBlob={shareImageBlob}
        />
      </div>
    </div>
  );
};

export default Loser;
